import './style.sass';

import React from 'react';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const ProcessCase = ({ listProcess }) => {
    return (
        <FullWrapper className="process-case">
            {listProcess.map((item, index) => (
                <div key={index} className="process-case__wrapper">
                    <div className="process-case__title">{item.title}</div>
                    {item.description && (
                        <div
                            dangerouslySetInnerHTML={{ __html: item.description }}
                            className="process-case__description"
                        />
                    )}
                    {item.subtitle && (
                        <div
                            dangerouslySetInnerHTML={{ __html: item.subtitle }}
                            className="process-case__subtitle"
                        />
                    )}
                    {item.list.map((list, idx) => (
                        <div key={idx} className="process-case__list">
                            <div className="process-case__number">{list.number}</div>
                            <div
                                dangerouslySetInnerHTML={{ __html: list.text }}
                                className="process-case__text"
                            />
                        </div>
                    ))}
                    {item.secondText && (
                        <div
                            dangerouslySetInnerHTML={{ __html: item.secondText }}
                            className="process-case__secondText"
                        />
                    )}
                </div>
            ))}
        </FullWrapper>
    );
};
export default ProcessCase;
